module.exports = __webpack_public_path__ + "img/circleColored.d0fe4f43.svg";